import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@/components/primitives/Button.jsx';
import Input from '@/components/primitives/Input.jsx';
import { requestPasswordReset } from '@/redux/requests/sessionRequests.js';
import AuthLayout from '../components/AuthLayout.jsx';
import AuthNotice from '../components/AuthNotice.jsx';
import describeAuthFailure from '../lib/describeAuthFailure.js';

/** Asks for a reset link. The answer is the same whether or not the email has an account. */
const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sentTo, setSentTo] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);
    const res = await requestPasswordReset({ email: email.trim() });
    setIsSubmitting(false);

    if (res?.success === false) {
      setError(describeAuthFailure(res));
      return;
    }

    setSentTo(email.trim());
  };

  return (
    <AuthLayout
      title="Reset your password"
      description="Enter the email you sign in with. Pieve sends a link to set a new password."
      footer={
        <Link className="auth-link" to="/sign-in">
          Back to sign in
        </Link>
      }>
      {sentTo ? (
        <AuthNotice tone="success">If an account uses {sentTo}, a reset link is on its way. It works once, for 60 minutes.</AuthNotice>
      ) : (
        <form className="auth-form" onSubmit={handleSubmit} noValidate>
          <AuthNotice>{error}</AuthNotice>
          <Input label="Email" type="email" name="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
          <div className="auth-form__submit">
            <Button type="submit" variant="primary" size="lg" loading={isSubmitting} disabled={!email.trim()}>
              Send reset link
            </Button>
          </div>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
